import Symbol from './Symbol';
import MarkerSymbol from './MarkerSymbol';
import CircleMarkerSymbol from './CircleMarkerSymbol';
import SquareMarkerSymbol from './SquareMarkerSymbol';
import RectangleMarkerSymbol from './RectangleMarkerSymbol';
import CrossMarkerSymbol from './CrossMarkerSymbol';
import TiltedCrossMarkerSymbol from './TiltedCrossMarkerSymbol';
import DoubleParallelMarkerSymbol from './DoubleParallelMarkerSymbol';
import TriangleMarkerSymbol from './TriangleMarkerSymbol';
import ImageMarkerSymbol from './ImageMarkerSymbol';
import MultiImageMarkerSymbol from './MultiImageMarkerSymbol';
import TextMarkerSymbol from './TextMarkerSymbol';
import TextImageSymbol from './TextImageSymbol';
import CompositeMarkerSymbol from './CompositeMarkerSymbol';
import LineSymbol from './LineSymbol';
import SimpleLineSymbol from './SimpleLineSymbol';
import CartoLineSymbol from './CartoLineSymbol';
import MarkerLineSymbol from './MarkerLineSymbol';
import HashLineSymbol from './HashLineSymbol';
import TextLineSymbol from './TextLineSymbol';
import TextLineWithMultiMarkersSymbol from './TextLineWithMultiMarkersSymbol';
import CenterTextLineSymbol from './CenterTextLineSymbol';
import EndMarkerLineSymbol from './EndMarkerLineSymbol';
import CenterMarkerLineSymbol from './CenterMarkerLineSymbol';
import CompositeLineSymbol from './CompositeLineSymbol';
import FillSymbol from './FillSymbol';
import SimpleFillSymbol from './SimpleFillSymbol';
import PatternFillSymbol from './PatternFillSymbol';
import LinearGradientFillSymbol from './LinearGradientFillSymbol';
import RadialGradientFillSymbol from './RadialGradientFillSymbol';
import CenterMarkerFillSymbol from './CenterMarkerFillSymbol';
import CompositeFillSymbol from './CompositeFillSymbol';
import VertexLineSymbol from './VertexLineSymbol';
import TextBackgroundSymbol from './TextBackgroundSymbol';
import SymbolFactory, { GetSymbolFactory } from './SymbolFactory';

export default {
    Symbol,
    MarkerSymbol,
    CircleMarkerSymbol,
    SquareMarkerSymbol,
    RectangleMarkerSymbol,
    CrossMarkerSymbol,
    TiltedCrossMarkerSymbol,
    TriangleMarkerSymbol,
    ImageMarkerSymbol,
    MultiImageMarkerSymbol,
    TextMarkerSymbol,
    CompositeMarkerSymbol,
    LineSymbol,
    SimpleLineSymbol,
    CartoLineSymbol,
    MarkerLineSymbol,
    HashLineSymbol,
    TextLineSymbol,
    CenterTextLineSymbol,
    EndMarkerLineSymbol,
    CenterMarkerLineSymbol,
    CompositeLineSymbol,
    FillSymbol,
    SimpleFillSymbol,
    PatternFillSymbol,
    LinearGradientFillSymbol,
    RadialGradientFillSymbol,
    CenterMarkerFillSymbol,
    CompositeFillSymbol,
    VertexLineSymbol,
    SymbolFactory,
    GetSymbolFactory,
    TextImageSymbol,
    TextBackgroundSymbol,
    DoubleParallelMarkerSymbol
};

